import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalvarsService } from 'src/app/services/globalvars.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css']
})
export class AddUserComponent implements OnInit {

  username = '';
  password = '';
  name = '';
  department = 0;
  departments: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getDepartments(tmpToken.accessToken)
      .then(value => {
        this.departments.push(value)
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  save() {
    if (this.department == 0) {
      return
    }
    if (this.username.length < 8 || !this.username) {
      return
    }
    if (this.password.length < 8 || !this.password) {
      return
    }

    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    let user = {
      username: this.username,
      password: this.password,
      name: this.name,
      department: this.department
    }

    this.rest.postUser(tmpToken.accessToken, user)
      .then(value => {
        this.router.navigateByUrl('/users');
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  cancel() {
    this.router.navigateByUrl('/users');
  }
  
}
